// TODO(MCCERTS-3063): true once the signed-in visitor has joined this cohort; there's no cohort enrollment data yet
export const useHasJoinedCohort = (): boolean => false
